import React, { useState } from 'react';
import { useWeb3React } from "@web3-react/core";
import { useDisclosure } from "@chakra-ui/react";
import { ethers, BigNumber } from 'ethers';
import coolEyesNFT from '../CoolEyesNFT.json';
import classNames from 'classnames';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';

const smartContractAddress = "0x01f6649Aae9E8608A6C2DAB367CdbF13b200A5CE";

const Mint = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        library,
        chainId,
        account,
        activate,
        deactivate,
        active
    } = useWeb3React();
    const [mintAmount, setMintAmount] = useState(1);
    const [cost, setCost] = useState(0.02);

    async function handleMint(){
        if(active){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(
                smartContractAddress,
                coolEyesNFT.abi,
                signer
            );

            try {
                const response = await contract.mint(BigNumber.from(mintAmount), {
                    value: ethers.utils.parseEther((0.02 * mintAmount).toString()),
                });
                console.log('response: ', response);
            } catch(err) {
                console.log("error: ", err);
            }
        }
    }

    const handleDecrement = () => {
        if(mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    }

    const handleIncrement = () => {
        if(mintAmount >= 3) return;
        setMintAmount(mintAmount + 1);
    }

    return(
        <section className={classNames("section", "center-content", "mint-section")}>
            <div className="container-sm">
                <div className="mint-container">
                    <h1>Eduverse NFT</h1>
                    <div className="flip-clock-container">
                        <FlipClockCountdown
                            to={new Date().getTime() + 29 * 24 * 3600 * 1000 + 5000}
                            className="flip-clock"
                            labels={['DAYS', 'HOURS', 'MINUTES', 'SECONDS']}
                        >
                            TODO - Render component when contdown is done
                        </FlipClockCountdown>
                    </div>
                    {active ? (
                        <div>
                            <div>
                                <img src={require("../assets/images/hidden.png")} width={400} height={400} alt="NFT Preview"/>
                                <button className="button button-primary button-wide-mobile button-sm mint-button" onClick={handleDecrement}>-</button>
                                <input type="number" value={mintAmount}/>
                                <button className="button button-primary button-wide-mobile button-sm mint-button" onClick={handleIncrement}>+</button>
                            </div>
                            <div>
                                Total: {mintAmount * cost} ETH
                            </div>
                            <div>
                                <button
                                    className="button button-primary button-wide-mobile button-sm mint-button"
                                    onClick={handleMint}
                                >
                                    Mint
                                </button>
                            </div>
                        </div>
                    ): (
                        <p>You must connect your wallet to mint</p>
                    )}
                </div>
            </div>
        </section>
    );
}

export default Mint;